export default {
  title01: "Météo actuelle ",
  title02: "24 Heures",
  title03: "Voir les prévisions météo sur 10 jours",
  title04: "IQA",
  title05: "Voir toutes les informations",
  title06: "Lever et coucher du soleil",
  title07: "Phase de la lune",
  title08: "La prochaine pleine lune",
  title09: "La prochaine nouvelle lune",
  title10: "JOUR",
  title11: "NUIT",
  title12: "Lever du soleil",
  title13: "Coucher du soleil",
  title14: "Lever de lune",
  title15: "Coucher de lune",
  title16: "Source",
  title17: "Début",
  title18: "Fin",
  title19: "Utiliser la localisation actuelle",
  title20: "Rechercher la ville",
  title21: "Température ressentie",
  title22: "Température ressentie à l'ombre",
  title23: "Maintenant",
  title24: "Aujourd'hui",
  title25: "DIM",
  title26: "LUN",
  title27: "MAR",
  title28: "MER",
  title29: "JEU",
  title30: "VEN",
  title31: "SAM",
  title32: "Chargement...",
  title33: "Maintenant",
  title34: "Horaire",
  title35: "Quotidien",
  title36: "Soleil & Lune",
  title37: "Qualité de l'Air",
  title38: "Contacter : xlf550402@gmail.com",
  title39: "Accord de Confidentialité",
  title40: "Droits d'Auteur © comfortweather.com 2020 - 2026. Tous droits réservés.",
  title41: "Données fournies par",
  title42: "Max",
  title43: "Min",
  title44: "Accepter",
  title45:
    "Merci d'utiliser ComfortWeather ! Pour mieux protéger vos droits et intérêts légaux, veuillez lire attentivement la ",
  title46: "Politique de Confidentialité",
  title47: " avant utilisation.",
  title48: "",
  title49: "Contacter : xyjph123@gmail.com",
  title50: "Droits d'Auteur © 24hweather.com 2020 - 2026. Tous droits réservés.",
  title51:
    "Merci d'utiliser 24hweather ! Pour mieux protéger vos droits et intérêts légaux, veuillez lire attentivement la ",
  title52: "Votre emplacement a changé. Voulez-vous le mettre à jour ?",
  title53: "Confirmer",
  title54: "Annuler",
  title55: "Retour",
  title56: "Actualités",
  title57: "Mise à jour de la météo...",
  title58: "Météo mise à jour",
  title59: "Voir tout",
  title60: "Droits d'Auteur © mobi321.com 2020 - 2026. Tous droits réservés.",
  title61: "Hier",
  title62: "Demain",
  title63: "Voir les prévisions météo sur 15 jours",
  title64: "Détails du jour",
  title65: "Rahu Kaal",
  title66: "indices de style de vie",
  title67: "indices de style de vie",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Difficile à sécher",
  title103: "Séchage lent",
  title104: "Sèche bien",
  title105: "Séchage rapide",
  title106: "Séchage très rapide",

  title107: "Ne convient pas",
  title108: "Expérience modeste",
  title109: "Bon pour s'amuser dans l'eau",
  title110: "Très approprié",
  title111: "Conditions parfaites",

  title112: "Favorisant la santé",
  title113: "Conditions neutres",
  title114: "Risque légèrement plus élevé",
  title115: "Risque élevé",
  title116: "À risque extrême",

  title117: "Ne convient pas",
  title118: "Plutôt convenable",
  title119: "Bon pour l'extérieur",
  title120: "Très approprié",
  title121: "Excellentes conditions",

  title122: "Conditions très sèches",
  title123: "Probablement sec",
  title124: "Légèrement sec",
  title125: "Pas probablement sec",
  title126: "Très peu probable sec",

  title127: "Non recommandé",
  title128: "Acceptable",
  title129: "Bonne journée",
  title130: "Très bonnes conditions",
  title131: "Conditions idéales",
};
